<div class="rs-root">
  <router-outlet></router-outlet>
  <!-- <rs-need-any-help></rs-need-any-help> -->
  <rs-spinner *ngIf="spinnerVisibility"></rs-spinner>
  <simple-notifications></simple-notifications>
</div>
